import { INCOMING_LINE_ITEMS } from "MODULES/IncomingQuotes/constants";

export const ACCOUNTING_HOLD = "accounting_hold";
export const AFTER_HOURS = "after_hours";
export const ATTACH_CERTIFICATE_OF_CONFORMANCE =
  "attach_certificate_of_conformance";
export const ATTACH_PACKING_SLIP = "attach_packing_slip";
export const BROKERED_EXCHANGE = "brokered_exchange";
export const DENIED_PARTY_HOLD = "denied_party_hold";
export const DISCREET = "discreet";
export const EXPORT_COMPLIANCE_HOLD = "export_compliance_hold";
export const INVOICE_PAID_DATE = "invoice_paid_date";
export const CORE_REPAIR_CHARGES_INVOICED = "core_repair_charges_invoiced";
export const CORE_REPAIR_INVOICE_NUMBER = "core_repair_invoice_number";
export const CORE_REPAIR_INVOICE_PAID = "core_repair_invoice_paid";
export const CORE_REPAIR_INVOICE_DUE_DATE = "core_repair_invoice_due_date";
export const CORE_REPAIR_INVOICE_AMOUNT_PAID =
  "core_repair_invoice_amount_paid";
export const CONTINGENT_ON_PASSING = "contingent_on_passing";
export const CREDIT_EXCHANGE = "credit_exchange";
export const CREDIT_TERMS = "credit_terms";
export const CUMULATIVE_COST_PER_UNIT = "cumulative_cost_per_unit";
export const CUSTOMER_DISPLAYED_SUBTOTAL = "customer_displayed_subtotal";
export const CUSTOMER_TO_PROVIDE_OWN_PAPERWORK =
  "customer_to_provide_own_paperwork";
export const PICTURES_REQUIRED = "pictures_required";
export const CONDITIONS = INCOMING_LINE_ITEMS.condition;
export const DOLLARS = "dollars";
export const EXCHANGE_AGREEMENT_HOLD = "exchange_agreement_hold";
export const EXCHANGE_EVAL_IN_PROGRESS = "exchange_eval_in_progress";
export const EXCHANGE_SPECIAL_INSTRUCTIONS = "exchange_special_instructions";
export const EXCHANGE_SALE = "exchange_sale";
export const EXCHANGE_TYPE = "exchange_type";
export const EXPECTED_DATE = "expected_date";
export const FLAT_EXCHANGE = "flat_exchange";
export const FLAT_EXCHANGE_FEE = "flat_exchange_fee";
export const LABOR_COST = "labor_cost";
export const OUTRIGHT = "outright";
export const OUTRIGHT_VALUE = "outright_value";
export const OUTSIDE_LABOR_COST = "outside_labor_cost";
export const PAID_IN_FULL = "paid_in_full";
export const PERCENTAGE = "percentage";
export const PART_COST = "part_cost";
export const CUSTOMER_QC_PREAPPROVAL_REQUIRED =
  "customer_qc_preapproval_required";
export const REASON = "reason";
export const REASON_FOR_HOLD = "reason_for_hold";
export const REASON_FOR_RELEASE = "reason_for_release";
export const RELEASE_FOR_SHIPMENT = "release_for_shipment";
export const RELEASED = "released";
export const RELEASE_FOR_SHIPMENT_DETAILS = "release_for_shipment_details";
export const REPAIR_FEE = "repair_fee";
export const REPAIR_ADMIN_CHARGE_TYPE = "repair_admin_charge_type";
export const REPAIR_ADMINISTRATION_CHARGE_DOLLARS =
  "repair_administration_charge_dollars";
export const REPAIR_ADMINISTRATION_CHARGE_PERCENTAGE =
  "repair_administration_charge_percentage";
export const REPAIR_ADMINISTRATION_FEE = "repair_administration_fee";
export const SALES_ORDER = "sales_order";
export const SECOND_SELLER_ID = "second_seller_id";
export const SELLER_ID = "seller_id";
export const SEND_CANCELLATION_EMAIL = "send_cancellation_email";
export const SEND_SALES_ORDER_ACKNOWLEDGEMENT =
  "send_sales_order_acknowledgement";
export const SHIP_TO_COMPANY_DISABLED = "ship_to_company_disabled";
export const SHIPPED_AT = "shipped_at";

export const SEND_SALES_ORDER_ACKNOWLEDGEMENT_LABEL = "Send SO Acknowledgment";

export const SPECIAL_INSTRUCTIONS = "special_instructions";

export const condition = cond => CONDITIONS[cond] || {};

export const CANCELLATION_REASONS = [
  {
    value: "failed_test_or_install",
    text: "Unit failed at test or install"
  },
  {
    value: "cancelled_purchase_order",
    text: "Cancelled Purchase Order"
  },
  {
    value: "cannot_accept_paperwork",
    text: "Cannot accept paperwork"
  },
  {
    value: "no_longer_required",
    text: "Unit no longer required"
  },
  {
    value: "wrong_unit_ordered",
    text: "Wrong unit ordered"
  },
  {
    value: "failed_inspection",
    text: "Unit failed incoming inspection"
  },
  {
    value: "export_compliance_caution",
    text: "Export Compliance Caution"
  },
  {
    value: "dom_not_acceptable_to_customer",
    text: "DOM not acceptable to customer"
  },
  {
    value: "der_rejected",
    text: "DER/s rejected"
  },
  {
    value: "nonpayment",
    text: "Non-payment"
  },
  {
    value: "qc_paperwork_rejected",
    text: "QC Paperwork was rejected"
  },
  {
    value: "tags_rejected",
    text: "Tags were rejected"
  },
  {
    value: "repair_station_rejected",
    text: "Repair Station was rejected"
  },
  {
    value: "time",
    text: "Unable to provide in a timely manner"
  },
  {
    value: "cancelled_by_customer",
    text: "Our customer's customer cancelled on them"
  },
  {
    value: "unacceptable_pictures",
    text: "Rejected due to pictures being unacceptable"
  },
  {
    value: "other",
    text: "Other"
  }
];

export const ATTACHMENT_TYPES = {
  commercial_invoice: {
    label: "Commercial Invoice"
  },
  core_return_paperwork: {
    label: "Core Return Paperwork"
  },
  credit_card_form: {
    label: "Credit Card Form"
  },
  customer_correspondence: {
    label: "Customer Correspondence"
  },
  customers_discreet_paperwork: {
    label: "Discreet Paperwork"
  },
  customer_purchase_order: {
    label: "Customer Purchase Order"
  },
  dangerous_goods_declaration: {
    label: "Dangerous Goods Declaration (DGD)"
  },
  end_user_agreement: {
    label: "End User Agreement"
  },
  external_link: {
    label: "External Link"
  },
  final_trace_paperwork: {
    label: "Final Trace Paperwork"
  },
  material_certification: {
    label: "Material Certification"
  },
  photos_final_packaging: {
    label: "Photos - Final Packaging"
  },
  photos_shipping_inspection: {
    label: "Photos - Shipping Inspection"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  rma_pre_authorization_form: {
    label: "RMA Pre-Authorization Form"
  },
  shippers_letter_of_instruction: {
    label: "Shipper's Letter of Instruction"
  },
  shipping_checklist: {
    label: "Shipping Checklist"
  },
  signed_exchange_agreement: {
    label: "Signed Exchange Agreement"
  },
  signed_pick_up_receipt: {
    label: "Signed Pick Up Receipt"
  },
  supplied_awb_bol: {
    label: "Supplied AWB/BOL"
  }
};

export const NOT_EXCHANGED = "not_exchanged";
export const SECOND_EXCHANGE = "second_exchange";
export const THIRD_EXCHANGE = "third_exchange";

export const EXCHANGE_PERCENT = 0.5;
export const THIRD_EXCHANGE_PERCENT = 0.75;

const base = "Are you sure you want to";

export const EXCHANGE_CONFIG = {
  [NOT_EXCHANGED]: {
    text: "Create Second Exchange",
    actionText: `${base} initiate a second exchange?`
  },
  [SECOND_EXCHANGE]: {
    text: "Create Third Exchange",
    actionText: `${base} initiate a third exchange?`
  }
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/constants.js